<template>
  <div class="home">
    <div id="header"><div id="page-title">AzusaDesigner</div></div>
    <div id="contents">
      <h2>プライバシーポリシー</h2>
      <h3>個人情報の利用目的</h3>
      <p>
        AzusaDesignerでは、任意でクラウドにご登録いただく時、メールアドレス、パスワードをご登録いただきます。<br>
        これらは、以下の目的でのみ使用致します。
      </p>
      <ul>
        <li>クラウドへのログイン、パスワードの再発行</li>
        <li>クラウドのデータなどに何かトラブルが発生した時、こちらから連絡を差し上げるため</li>
      </ul>
      <h3>個人情報の第三者への開示</h3>
      <p>
        AzusaDesignerでは、個人情報はHTTPS通信などでのみ取り扱い適切に管理し、以下の場合を除いて第三者に開示することはありません。
      </p>
      <ul>
        <li>本人のご了解がある場合</li>
        <li>法令等の定めにより、開示が必要となる場合</li>
      </ul>
      <p>
        ご本人からの個人データの開示、訂正、追加、削除、利用停止のご希望の場合には、ご本人であることを確認させていただいた上、速やかに対応させていただきます。
      </p>
    </div>
    <div id="footer">
      <a href="https://twitter.com/azusadesigner">Twitter</a> | <a href="https://note.com/askyqq/m/mb08efa34423d">お知らせ</a><br>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class PrivacyPolicy extends Vue {
}
</script>

<style lang="scss" scoped>
@import '@/css/common.scss';

#header {
  height: 44px;
  color: var(--accent-color);
  background: $accent-text-color;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  #page-title {
    flex: 1;
    text-align: center;
    height: 44px;
    line-height: 44px;
    font-weight: bold;
    font-size: 22px;
    cursor: default;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

#contents {
  width: 80vw;
  max-width: 800px;
  margin: 36px auto;
  h2, h3 {
    text-align: center;
    margin-top: 16px;
  }
}

#footer {
  text-align: center;
  margin-top: 36px;
  color: #aaa;
  a {
    color: #777;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
